import { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

function getTimeUntilMidnight() {
  const now = new Date();
  const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  const diff = Math.max(0, midnight - now);
  return {
    hours: Math.floor(diff / (1000 * 60 * 60)),
    minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((diff % (1000 * 60)) / 1000),
  };
}

function padTime(n) {
  return String(n).padStart(2, '0');
}

export function OfferCountdown({ size = 'default', className = '' }) {
  const isLarge = size === 'large';
  const isBanner = size === 'banner';
  const [timeLeft, setTimeLeft] = useState(getTimeUntilMidnight);

  useEffect(() => {
    const tick = () => setTimeLeft(getTimeUntilMidnight());
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  const units = [
    { value: timeLeft.hours, label: 'Horas' },
    { value: timeLeft.minutes, label: 'Min' },
    { value: timeLeft.seconds, label: 'Seg' },
  ];

  return (
    <div
      className={`flex items-center bg-yellow-500/10 border border-yellow-500/30 backdrop-blur-md shadow-inner shrink-0 w-full sm:w-auto justify-center ${
        isLarge
          ? 'h-14 gap-2.5 rounded-2xl px-4'
          : isBanner
            ? 'gap-3 sm:gap-2.5 rounded-xl px-4 py-3 sm:px-3.5 sm:py-2'
            : 'gap-2 rounded-lg px-2.5 py-1.5'
      } ${className}`}
      role="timer"
      aria-live="polite"
      aria-label="Tiempo restante hasta medianoche"
    >
      <Clock
        className={`text-yellow-400 shrink-0 ${
          isLarge ? 'w-5 h-5' : isBanner ? 'w-5 h-5 sm:w-4 sm:h-4' : 'w-3 h-3'
        }`}
        strokeWidth={2.5}
      />
      <p
        className={`font-bold leading-tight text-yellow-400/95 uppercase tracking-wide whitespace-nowrap ${
          isLarge
            ? 'text-xs sm:text-sm'
            : isBanner
              ? 'text-xs sm:text-[10px]'
              : 'text-[9px] sm:text-[10px]'
        }`}
      >
        Aanbod · 00:00
      </p>
      <div className={`flex items-center ${isLarge || isBanner ? 'gap-1' : 'gap-0.5'}`}>
        {units.map((unit, i) => (
          <span key={unit.label} className="flex items-center gap-0.5">
            <span className={`flex items-center ${isLarge || isBanner ? 'gap-0' : 'flex-col'}`}>
              <span
                className={`font-black tabular-nums leading-none text-yellow-400 bg-black/30 border border-yellow-500/25 rounded text-center ${
                  isLarge
                    ? 'text-lg px-2 py-1 min-w-[2.25rem]'
                    : isBanner
                      ? 'text-xl sm:text-base px-2.5 py-1 sm:px-2 sm:py-0.5 min-w-[2.75rem] sm:min-w-[2rem]'
                      : 'text-sm px-1.5 py-0.5 min-w-[1.65rem]'
                }`}
              >
                {padTime(unit.value)}
              </span>
              {!isLarge && !isBanner && (
                <span className="text-[7px] text-white/50 font-bold uppercase mt-px hidden sm:block">
                  {unit.label}
                </span>
              )}
            </span>
            {i < units.length - 1 && (
              <span
                className={`text-yellow-500/80 font-bold ${
                  isLarge
                    ? 'text-base'
                    : isBanner
                      ? 'text-lg sm:text-sm'
                      : 'text-xs pb-2 sm:pb-2.5'
                }`}
                aria-hidden
              >
                :
              </span>
            )}
          </span>
        ))}
      </div>
    </div>
  );
}
